export const mapStatus = (props, field) => {
    const takeStatus = () => {
        if (!field)
            return;
        if (field.loading || field.validating)
            return 'loading';
        if (field.invalid)
            return 'error';
        if (field.warnings?.length)
            return 'warning';
        return field.decoratorProps?.feedbackStatus;
    };
    const takeState = (state) => {
        if (state === 'validating' || state === 'pending')
            return 'loading';
        return state;
    };
    return {
        ...props,
        state: takeState(props.state) || takeStatus(),
    };
};
